import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import i18n from './i18n'
import moment from 'moment'


Vue.config.productionTip = false

// i18n.locale = document.documentElement.lang.substr(0, 2);
let locale = navigator.language || navigator.userLanguage;
i18n.locale = locale.split('-')[0]
moment.locale(i18n.locale)

Vue.filter('formatDate', function(val) {
  if (val) {
    return moment(String(val)).format('LL')
  }
});

Vue.filter('formatDateTime', function(val) {
  if (val) {
    return moment(String(val)).format('LLL')
  }
});

Vue.filter('toUppercase', function(val) {
  if (!val)
    return ''

  return val.toString().toUpperCase()
});

Vue.filter('cleanUrl', function(val) {
  if (!val)
    return ''

  return val.toString().replace(/(^\w+:|^)\/\//, '')
});


new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
